/**
 * Menüde BTrans SFP varsa detail + sibling route'ları routeList'e ekler.
 */
export const BTRANS_SFP_ROUTE_PATHS = [
  "/btrans-sfp/ozet",
  "/btrans-sfp/dosyalar",
  "/btrans-sfp/dosyalar/:id",
  "/btrans-sfp/satirlar",
];

export const menuHasBtransSfp = (items) => {
  if (!Array.isArray(items)) return false;
  return items.some((item) => {
    const url = ((item && item.url) || "").toLowerCase();
    const code = String(
      (item && (item.code || item.pageCode || item.Code || item.name)) || ""
    ).toLowerCase();
    if (url.indexOf("btrans-sfp") !== -1 || code.indexOf("btrans-sfp") !== -1) {
      return true;
    }
    return menuHasBtransSfp(item && item.children);
  });
};

export const ensureBtransSfpRoutes = (routeList, allRoutes) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;

  BTRANS_SFP_ROUTE_PATHS.forEach((path) => {
    const route = allRoutes.find((item) => item && item.path === path);
    if (route && !next.some((item) => item.path === route.path)) {
      next.push(route);
    }
  });
  return next;
};
